import { Injectable } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { CheckDto } from "src/app/shared/models/check-dto";
import { Store } from "src/app/shared/models/store";
import { SurveyResponse, VenueSurveyItem } from "src/app/shared/models/survey.model";
import { AppService } from "./app.service";
import { FocuslinkService } from "./focuslink.service";
import { OOVenueService } from "./venue-service";

@Injectable({
	providedIn: "root",
})
export class SurveyService {
	timeOpened: string;
	checkNumber: number;
	seatNumber: number;
	surveyId: string;

	surveyComplete: boolean = false;

	check: BehaviorSubject<CheckDto> = new BehaviorSubject(null);
	survey: BehaviorSubject<VenueSurveyItem> = new BehaviorSubject<VenueSurveyItem>(null);
	surveyList: BehaviorSubject<VenueSurveyItem[]> = new BehaviorSubject<VenueSurveyItem[]>([]);

	surveyResponse: BehaviorSubject<SurveyResponse> = new BehaviorSubject<SurveyResponse>(new SurveyResponse());
	surveyResponseList: BehaviorSubject<SurveyResponse[]> = new BehaviorSubject<SurveyResponse[]>([]);

	venueKey: number;
	venue: BehaviorSubject<Store> = new BehaviorSubject<Store>(null);
	venueSubscription: Subscription;

	constructor(public app: AppService, private focuslink: FocuslinkService, private venueService: OOVenueService) {}

	startSurvey() {
		this.getSurvey(this.venueKey, this.surveyId);
		this.getCheck(this.venueKey, this.checkNumber, this.seatNumber, this.timeOpened);
		this.getVenue(this.venueKey);
	}

	async getSurvey(venueKey: number, surveyId: string) {
		this.venueKey = venueKey;
		const survey = await this.focuslink.surveyGetOne(venueKey, surveyId, true);
		this.survey.next(new VenueSurveyItem(survey));
		return this.survey.value;
	}

	async getCheck(venueKey: number, checkNumber: number, seatNumber: number, timeOpened: string) {
		const params = `checkNumber=${checkNumber}&timeOpened=${timeOpened}`;

		try {
			const response = await this.focuslink.checksGetByParams(this.venueKey, params);
			if (Array.isArray(response)) {
				if (response.length > 0) {
					this.check.next(new CheckDto(response[0]));
				} else {
					throw new Error("No check found");
				}
			} else {
				if (response.checkKey) {
					this.check.next(new CheckDto(response));
				} else {
					throw new Error("No check found");
				}
			}
			console.log(this.check.value);
			return this.check.next;
		} catch (error) {}
	}

	async getVenue(venueKey: number) {
		const venue = await this.focuslink.venueGet(venueKey);
		this.venue.next(venue);
		return venue;
	}

	buildSurveyForSubmit() {
		this.surveyResponse.value.venueKey = this.venueKey;
		this.surveyResponse.value.checkKey = this.check.value.checkKey;
		this.surveyResponse.value.seatKey = this.seatNumber;
		this.surveyResponse.value.surveyKey = this.survey.value.sk;
		this.surveyResponse.value.questions = this.survey.value.questions.map((question) => question);
		return this.surveyResponse.value;
	}

	async submitCompletedSurvey() {
		try {
			this.surveyResponse.next(this.buildSurveyForSubmit());
			const response = await this.focuslink.checkSurveyPost(
				this.surveyResponse.value.venueKey,
				this.surveyResponse.value.checkKey,
				this.surveyResponse.value
			);
			this.surveyComplete = true;
			this.app.loading(false);
			return response;
		} catch (error) {
			this.surveyComplete = true;
			this.app.loading(false);
		}
	}

	async surveyGetAll() {
		const resp = await this.focuslink.surveyGetAll(this.venueService.subscriptionVenue.value.key);
		this.surveyList.next(resp.map((i) => new VenueSurveyItem(i)));
		return this.surveyList.value;
	}

	async surveyResponseGetAll() {
		this.venueKey = this.venueService.subscriptionVenue.value.key;
		const resp = await this.focuslink.surveyResponseGetAll(this.venueService.subscriptionVenue.value.key);
		this.surveyResponseList.next(resp.map((i) => new SurveyResponse(i)));
		return this.surveyResponseList.value;
	}

	setVenueSubscription() {
		this.venueSubscription = this.venueService.subscriptionVenue.subscribe((venue) => {
			if (venue && this.venueKey !== venue.key) {
				this.surveyList.next([]);
				this.surveyResponseList.next([]);
				this.surveyResponseGetAll();
				this.surveyGetAll();
			}
		});
	}
}
